import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private _darkMode = signal(this.loadPreference());
  readonly darkMode = this._darkMode.asReadonly();

  constructor() {
    this.apply(this._darkMode());
  }

  toggle() {
    const next = !this._darkMode();
    this._darkMode.set(next);
    localStorage.setItem('fish-dark-mode', String(next));
    this.apply(next);
  }

  private loadPreference(): boolean {
    const saved = localStorage.getItem('fish-dark-mode');
    if (saved !== null) return saved === 'true';
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
  }

  private apply(dark: boolean) {
    document.documentElement.classList.toggle('dark-mode', dark);
  }
}
